import { CATEGORIES, articleHref } from "../data/articles.js";
import { useArticle, useArticles, formatDate } from "../lib/editApi.js";
import ArticleCard from "../site/ArticleCard.jsx";

export default function ArticlePage({ category, slug }) {
  const { article, state } = useArticle(category, slug);
  const { articles } = useArticles();
  const label = CATEGORIES[category]?.label || category;

  if (state === "missing") {
    return (
      <div className="container-page py-32 text-center">
        <span className="eyebrow">Not found</span>
        <h1 className="section-title mt-3">We can't find that guide</h1>
        <p className="prose-body mt-3">It may have been renamed or unpublished.</p>
        <a href="/edit/" className="btn-primary mt-8 inline-flex">Browse The Edit</a>
      </div>
    );
  }
  if (!article) return <div className="container-page py-32"><p className="prose-body">Loading…</p></div>;

  const related = articles.filter(a => a.slug !== article.slug && a.category === article.category).slice(0, 3);
  const fallback = articles.filter(a => a.slug !== article.slug).slice(0, 3);
  const more = related.length ? related : fallback;

  return (
    <article>
      {article.img && (
        <div className="h-[38vh] min-h-[260px] w-full overflow-hidden bg-sand-100 md:h-[46vh]">
          <img src={article.img} alt={article.title} style={{ objectPosition: article.imgPosition || "center center" }} className="h-full w-full object-cover"/>
        </div>
      )}

      <div className="container-page py-12 md:py-16">
        <div className="mx-auto max-w-3xl">
          <nav className="text-sm text-ink-muted">
            <a href="/edit/" className="hover:text-ocean-700">The Edit</a>
            <span className="px-2">/</span>
            <a href={`/${category}/`} className="hover:text-ocean-700">{label}</a>
          </nav>

          <header className="mt-6">
            <span className="eyebrow">{label}</span>
            <h1 className="section-title mt-3">{article.title}</h1>
            {article.excerpt && <p className="prose-body mt-5 text-lg">{article.excerpt}</p>}
            {article.date && (
              <p className="mt-6 text-xs uppercase tracking-[0.14em] text-ink-muted">
                Published {formatDate(article.date)}
              </p>
            )}
          </header>

          {/* Body is HTML written by us in the Edit admin, behind an admin token —
              first-party content, not user submissions. */}
          {article.body
            ? <div className="article-body mt-10" dangerouslySetInnerHTML={{ __html: article.body }}/>
            : <p className="prose-body mt-10">This guide is being written.</p>}

          <div className="mt-14 rounded-2xl bg-sand-50 p-8">
            <span className="eyebrow">Ready when you are</span>
            <h2 className="mt-2 font-display text-2xl leading-tight text-ink">Find a place to stay in Hawaiʻi</h2>
            <p className="prose-body mt-2">Real local rates with taxes included, across all six islands.</p>
            <a href="/results/" className="btn-primary mt-5 inline-flex">Search stays</a>
          </div>
        </div>
      </div>

      {more.length > 0 && (
        <div className="container-page pb-20">
          <div className="mx-auto max-w-5xl">
            <h2 className="section-title text-2xl">Keep reading</h2>
            <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {more.map(a => <ArticleCard key={`${a.category}/${a.slug}`} article={a}/>)}
            </div>
          </div>
        </div>
      )}
    </article>
  );
}
